import { Box, ResponsiveLayout, Typography } from "@bca/ui-library";
import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import styled from "styled-components";
import { PositionProps, position } from "styled-system";
import Colours from "../../types/colours";
import { StoreType } from "../../redux/StoreType";
import { GET_VENDOR_IMPERSONATION_STATE } from "../../redux/slices/impersonationSlice";

const StyledBox = styled(Box)<PositionProps>`
  ${position};
`;

const ImpersonationBanner = () => {
  const [isImpersonationBannerOpen, setIsImpersonationBannerOpen] =
    useState<boolean>(false);

  const {
    impersonation: { isVendorImpersonationSet, impersonatedUserEmail },
  }: StoreType = useSelector(GET_VENDOR_IMPERSONATION_STATE, shallowEqual);

  useEffect(() => {
    setIsImpersonationBannerOpen(isVendorImpersonationSet);
  }, [isVendorImpersonationSet]);

  return (
    <>
      {isImpersonationBannerOpen && (
        <StyledBox
          backgroundColor={Colours.PINK_INFO_BACKGROUND}
          position="sticky"
          top={0}
          zIndex={5}
          data-testid="vendor-impersonation-banner"
        >
          <ResponsiveLayout
            maxHeight="52px"
            minHeight="42px"
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            overflow="hidden"
          >
            <Box alignSelf="center" my={3}>
              <Box display="flex" flexWrap="wrap">
                <Typography
                  variant="body-small"
                  my={0}
                  mr={1}
                  lineHeight="18px"
                >
                  You’re viewing
                </Typography>
                <Typography
                  variant="body-small"
                  my={0}
                  fontWeight="bold"
                  lineHeight="18px"
                  data-testid="vendor-impersonation-banner-email"
                >
                  {impersonatedUserEmail}
                </Typography>
              </Box>
            </Box>
          </ResponsiveLayout>
        </StyledBox>
      )}
    </>
  );
};

export default ImpersonationBanner;
